import styled from 'styled-components';
import { HashRouter } from 'react-router-dom';

import { useGetRaffle } from './data';
import Navbar from './components/Navbar.jsx';
import SetUp from './components/SetUp.jsx';
import Live from './components/Live.jsx';
import PickWinners from './components/PickWinners.jsx';
import useSort from '../../shared/Sort/useSort';
import { PRIZE_STATUS } from './utils/constants';

const ClientAdminPrizesContainerWrapper = styled.div`
  margin: 24px;
`;

const ClientAdminPrizesContent = () => {
  const { sortingStatus, changeSort } = useSort();

  const raffle = useGetRaffle({ ...sortingStatus });

  return (
    <ClientAdminPrizesContainerWrapper>
      <Navbar raffle={raffle} />
      {raffle.status === PRIZE_STATUS.set_up && <SetUp raffle={raffle} />}
      {raffle.status === PRIZE_STATUS.live && <Live raffle={raffle} />}
      {(raffle.status === PRIZE_STATUS.pick_winners ||
        raffle.status === PRIZE_STATUS.picked_winners) && (
        <PickWinners
          raffle={raffle}
          sortingStatus={sortingStatus}
          changeSort={changeSort}
        />
      )}
    </ClientAdminPrizesContainerWrapper>
  );
};

const ClientAdminPrizes = () => {
  return (
    <HashRouter hashType="noslash">
      <ClientAdminPrizesContent />
    </HashRouter>
  );
};

export default ClientAdminPrizes;
